export const INTAKE_ASSESSMENT_FLOW_NAME = 'Intake Assessment';
export const DAILY_CHECKIN_FLOW_NAME = 'Daily Checkin';

const INTAKE_OPTIONAL_AUTHENTICATED_PATHS = new Set(['/snapshot']);

export const isIntakeOptionalAuthenticatedPath = (path: string) =>
  INTAKE_OPTIONAL_AUTHENTICATED_PATHS.has(path.split(/[?#]/, 1)[0]);
